import { render, staticRenderFns } from "./OrderCancellation.vue?vue&type=template&id=3d1bb63e&scoped=true&"
import script from "./OrderCancellation.vue?vue&type=script&lang=js&"
export * from "./OrderCancellation.vue?vue&type=script&lang=js&"
import style0 from "./OrderCancellation.vue?vue&type=style&index=0&id=3d1bb63e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1bb63e",
  null
  
)

export default component.exports